import { FC, useEffect, useState } from "react";
import styles from "./styles/index.module.scss";
import { LotSelectorInput } from ".";
import { IdTableVariant, SearchOption } from "../../@types/enumsGlobal";
import { ILotDTO } from "../../libs/coreapi-dto/accounting/lot";
import { IOption } from "../selects/select";
import FlexRow from "../controls/FlexRow";
import FlexColumn from "../controls/FlexColumn";
import { KizBarcodeButton } from "../buttons/iconButtons/kiz/KizBarcodeCollection";
import { SelectControl } from "../controls/SelectControl";
import { SettingsButtonModal } from "../buttons/iconButtons/settingsButton/SettingsButtonModal";
import { GridFilterAction } from "../../system/hooks/useGridFilter";
import { ISearchQueryInfo } from "./lotSelectorInput";

interface IKizButton {
    disabled?: boolean;
    onClick: () => void;
}

interface ILotSelectorPanelProps {
    disabled?: boolean;
    barcodeScan?: boolean;
    onlyLotRemain?: boolean;
    kizButton?: IKizButton;
    searchOption?: SearchOption;
    gridFilter?: IGridFilter;
    dispatchGridFilter?: (value: GridFilterAction) => void;
    onSelect?: (value: ILotDTO | ILotDTO[], searchQuery?: ISearchQueryInfo, decodedBarcode?: string) => void;
    setScanData?: (value) => void
    setSearchOption?: (value) => void
    documentIdTable?: IdTableVariant
    activateGroupProcessing?: boolean
    autoFocus?: boolean;
    lastSearchQuerySettings?: ILastSearchQuerySettings;
    key?: string
    idStoreGlobal?: string | null;
}

const LotSelectorPanel: FC<ILotSelectorPanelProps> = (props) => {
    
    const [searchOption, setSearchOption] = useState<SearchOption>(props.searchOption ?? SearchOption.goodsName);
    const searchOptionList: IOption[] = [
        { value: SearchOption.kizOrKizBox, displayName: "КИЗ/Короб" },
        { value: SearchOption.barcode, displayName: "Штрих-код" },
        { value: SearchOption.goodsName, displayName: "Товар" },
        { value: SearchOption.goodsCodeBylot, displayName: "Код товара" },
        { value: SearchOption.gtinSgtin, displayName: "GTIN SGTIN" },
    ];

    useEffect(() => {
        props.setSearchOption?.(searchOption);
    },[searchOption])

    return (
        <>
            <FlexRow>
                {props.kizButton && (
                    <FlexColumn className={styles.kiz}>
                        <KizBarcodeButton sizeVariant="big" disabled={props.kizButton?.disabled} onClick={() => props.kizButton?.onClick?.()} />
                    </FlexColumn>
                )}
                <FlexColumn className={styles.lot}>
                    <LotSelectorInput
                        disabled={props.disabled}
                        barcodeScan={props.barcodeScan}
                        onlyLotRemain={props.onlyLotRemain}
                        gridFilter={props.gridFilter}
                        dispatchGridFilter={props.dispatchGridFilter}
                        searchOption={searchOption}
                        onSelect={(value, searchData, decodedBarcode) => props.onSelect?.(value, searchData,decodedBarcode)}
                        setScanData={props.setScanData}
                        documentIdTable={props.documentIdTable}
                        activateGroupProcessing={props.activateGroupProcessing}
                        lastSearchQuerySettings = {props.lastSearchQuerySettings}
                        autoFocus={props.autoFocus}
                        key={props.key}
                        idStoreGlobal={props.idStoreGlobal}
                    />
                </FlexColumn>
                <FlexColumn className={styles.options}>
                    <SelectControl
                        disabled={props.disabled}
                        barcodeScan={props.barcodeScan}
                        options={searchOptionList}
                        value={searchOptionList.find((item) => item.value === searchOption)}
                        onSelect={(value) => setSearchOption(value.value)}
                    />
                </FlexColumn>
                <FlexColumn className={styles.settings}>
                    <SettingsButtonModal disabled={props.disabled} />
                </FlexColumn>
            </FlexRow>
        </>
    );
};

export default LotSelectorPanel;
